const { fetchJSON } = window.BAO.Utils

class PreorderPrompt extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.listeners.add(this.els.submit.element, 'click', this.handleSubmit)
    this.listeners.add(this.els.close.element, 'click', this.handleClose)
  }

  async handleSubmit () {
    const matchedForm = document.querySelector(`#${this.dataset.formId}`)

    if (!matchedForm) return

    await fetchJSON(`${window.routes.cartClear}`)

    matchedForm.dispatchEvent(new Event('submit'))

    window.drawers.activeDrawerKey = 'cart'
  }

  handleClose () {
    window.drawers.activeDrawerKey = ''
  }
}

if (!customElements.get('preorder-prompt')) {
  customElements.define('preorder-prompt', PreorderPrompt)
}
